/* Everyday Endurance — "coleção com produto fixado" (ee-pin-first.js)
   ---------------------------------------------------------------------------
   Quem chega numa página de coleção vinda de anúncio vê o produto clicado em
   1º lugar; o resto da coleção vem normal depois. Arquivo da EE — não depende
   de código do BMP além do markup padrão da grade (Horizon 4.1.3):
     results-list > ul[ref="grid"] > li[ref="cards[]"] > (div.bmp-card-global-card) > product-card

   Carregado pela seção custom-liquid "EE — Produto fixado (do not remove)"
   (chave ee_pin_first em templates/collection.json), que também tem o
   "boot" inline: marca <html class="ee-pin-pending"> (esconde os cards sem
   mudar o layout), dispara cedo o pedido do card/coleção e tem um failsafe
   que revela a grade em 3,5 s aconteça o que acontecer.

   Parâmetros da URL:
     first   handle do produto OU URL completa do produto (codificada ou não —
             formato do {{product.url | urlencode}} do Meta). Handle e variant
             são extraídos de dentro da URL.
     variant id da variante (opcional; o da URL de fora vence o de dentro)
     limit   total de produtos exibidos (opcional; esconde a paginação)
     source  handle da coleção que preenche o resto (opcional; padrão: a atual)

   Card de produto fora da grade (ou com variante): vem pronto do servidor
   pelo modelo alternativo templates/product.ee-pin-card.json
   (/products/<handle>?variant=<id>&view=ee-pin-card, layout: false), que tem
   os MESMOS blocos do card da coleção (foto, bolinhas, título, nome da cor,
   preço). Se esse pedido falhar, tenta o card simples do BMP
   (?section_id=bmp-curated-product-card). Se tudo falhar, a coleção fica
   como veio do servidor.

   Se o recurso do BMP ("BMP Curated First", mesmo parâmetro) estiver ligado,
   este script não faz nada — os dois nunca rodam juntos. */
(function () {
  'use strict';

  var CARD_TIMEOUT = 3000;   // ms desde o boot para o card chegar
  var SOURCE_TIMEOUT = 3000; // ms desde o boot para a coleção "source" chegar

  var E = window.EEPin || (window.EEPin = { t0: Date.now() });
  var html = document.documentElement;

  function reveal() {
    html.classList.remove('ee-pin-pending');
    html.classList.remove('ee-pin-src');
    if (E.fail) { clearTimeout(E.fail); E.fail = 0; }
  }

  function warn(msg) {
    if (window.console && console.warn) console.warn('[ee-pin-first] ' + msg);
  }

  /* ---------- parâmetros ---------- */

  function parseRequest(search) {
    var q = new URLSearchParams(search);
    var first = q.get('first');
    if (!first) return null;
    var handle = first;
    var variant = q.get('variant');
    var cand = first;
    if (!/^https?:\/\//i.test(cand) && cand.indexOf('/products/') === -1) {
      try {
        var dec = decodeURIComponent(cand);
        if (/^https?:\/\//i.test(dec) || dec.indexOf('/products/') !== -1) cand = dec;
      } catch (e) { /* handle com "%" literal */ }
    }
    if (cand.indexOf('/products/') !== -1) {
      try {
        var u = new URL(cand, location.origin);
        var parts = u.pathname.split('/');
        var i = parts.indexOf('products');
        handle = i !== -1 && parts[i + 1] ? parts[i + 1] : '';
        if (!variant) variant = u.searchParams.get('variant');
      } catch (e) { handle = ''; }
    }
    handle = String(handle || '').split('?')[0].split('#')[0].split('/').pop();
    try { handle = decodeURIComponent(handle); } catch (e) { /* mantém */ }
    handle = handle.trim().toLowerCase();
    if (!handle || handle.length > 255 || /[\s<>"']/.test(handle)) return null;
    variant = String(variant || '').replace(/[^0-9]/g, '') || null;
    var limit = parseInt(q.get('limit') || '', 10);
    var source = String(q.get('source') || '').trim().toLowerCase().replace(/[^a-z0-9\-_À-￿]/g, '');
    var page = parseInt(q.get('page') || '1', 10) || 1;
    return {
      handle: handle,
      variant: variant,
      limit: limit > 0 ? limit : 0,
      source: source || '',
      page: page,
      sortBy: q.get('sort_by') || ''
    };
  }

  function root() {
    var r = E.root || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function cardUrl(req) {
    return root() + 'products/' + encodeURIComponent(req.handle) + '?view=ee-pin-card' +
      (req.variant ? '&variant=' + req.variant : '');
  }

  function bmpCardUrl(req) {
    return root() + 'products/' + encodeURIComponent(req.handle) +
      (req.variant ? '?variant=' + req.variant + '&' : '?') + 'section_id=bmp-curated-product-card';
  }

  function sourceUrl(req, sectionId) {
    return root() + 'collections/' + encodeURIComponent(req.source) + '?section_id=' +
      encodeURIComponent(sectionId) + (req.sortBy ? '&sort_by=' + encodeURIComponent(req.sortBy) : '');
  }

  function getText(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(url + ' → ' + r.status);
      return r.text();
    });
  }

  // Promessa que rejeita quando o prazo (contado desde o boot) acaba.
  function withDeadline(promise, ms) {
    var left = Math.max(0, ms - (Date.now() - (E.t0 || Date.now())));
    return new Promise(function (resolve, reject) {
      var t = setTimeout(function () { reject(new Error('timeout')); }, left);
      promise.then(function (v) { clearTimeout(t); resolve(v); },
                   function (e) { clearTimeout(t); reject(e); });
    });
  }

  /* ---------- grade ---------- */

  function getGrid() {
    var list = document.querySelector('results-list');
    return list && (list.querySelector('[ref="grid"]') || list.querySelector('.product-grid'));
  }

  function getCards(grid) {
    var out = [];
    for (var n = grid.firstElementChild; n; n = n.nextElementSibling) {
      if (n.getAttribute('ref') === 'cards[]' || n.classList.contains('product-grid__item')) out.push(n);
    }
    return out;
  }

  function linkMatches(href, handle) {
    if (!href) return false;
    var path;
    try { path = decodeURIComponent(new URL(href, location.origin).pathname).toLowerCase(); }
    catch (e) { return false; }
    var m = '/products/' + handle;
    var at = path.indexOf(m);
    if (at === -1) return false;
    var next = path.charAt(at + m.length);
    return next === '' || next === '/';
  }

  function matchesHandle(el, handle) {
    var links = el.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      if (linkMatches(links[i].getAttribute('href'), handle)) return true;
    }
    return false;
  }

  function findCard(grid, handle) {
    var cards = getCards(grid);
    for (var i = 0; i < cards.length; i++) if (matchesHandle(cards[i], handle)) return cards[i];
    return null;
  }

  function moveToFront(grid, li) {
    var cards = getCards(grid);
    var first = cards[0];
    if (!first || first === li) return;
    if (first.dataset.page) li.dataset.page = first.dataset.page;
    grid.insertBefore(li, first);
  }

  /* ---------- placeholder (mesmo lugar, mesmo tamanho) ---------- */

  function makePlaceholder(grid) {
    var sib = getCards(grid)[0];
    var li = document.createElement('li');
    li.className = (sib ? sib.className.replace(/product-grid__item--\d+/g, '') : 'product-grid__item') + ' ee-pin-slot';
    li.setAttribute('ref', 'cards[]');
    if (sib && sib.dataset.page) li.dataset.page = sib.dataset.page;
    var ratio = '4 / 5';
    var media = sib && (sib.querySelector('.product-media-container') || sib.querySelector('.card-gallery'));
    if (media) {
      var r = media.getBoundingClientRect();
      if (r.width && r.height) ratio = Math.round(r.width) + ' / ' + Math.round(r.height);
    }
    li.innerHTML = '<div class="ee-pin-ph" aria-hidden="true"><div class="ee-pin-ph__media" style="aspect-ratio:' +
      ratio + '"></div><div class="ee-pin-ph__line"></div><div class="ee-pin-ph__line ee-pin-ph__line--short"></div></div>';
    return li;
  }

  /* ---------- card vindo do servidor ---------- */

  // Extrai o card do HTML e prepara ANTES de entrar na página (foto da cor,
  // links com ?variant=, prioridade da imagem) — nada pisca depois.
  function buildCard(htmlText, req) {
    var doc = new DOMParser().parseFromString(htmlText, 'text/html');
    var pc = null;
    var cards = doc.querySelectorAll('product-card');
    for (var i = 0; i < cards.length; i++) {
      if (matchesHandle(cards[i], req.handle)) { pc = cards[i]; break; }
    }
    if (!pc) return null;
    var rootEl = pc.parentElement && pc.parentElement.classList.contains('bmp-card-global-card') ? pc.parentElement : pc;
    var frag = document.createDocumentFragment();
    // estilos inline que o bloco emite junto (se houver)
    var host = rootEl.parentElement;
    if (host) {
      var styles = host.querySelectorAll(':scope > style');
      for (var s = 0; s < styles.length; s++) frag.appendChild(document.importNode(styles[s], true));
    }
    var node = document.importNode(rootEl, true);
    frag.appendChild(node);
    var info = prepareCard(node, req);
    return { frag: frag, productId: pc.getAttribute('data-product-id'), info: info };
  }

  function prepareCard(node, req) {
    var info = { variantImage: false };
    if (req.variant) {
      var links = node.querySelectorAll('a[href*="/products/"]');
      for (var i = 0; i < links.length; i++) {
        var href = links[i].getAttribute('href');
        if (!linkMatches(href, req.handle)) continue;
        try {
          var u = new URL(href, location.origin);
          u.searchParams.set('variant', req.variant);
          links[i].setAttribute('href', u.pathname + u.search + u.hash);
        } catch (e) { /* mantém */ }
      }
      // A bolinha da cor da variante vem marcada pelo servidor (?variant=).
      var input = node.querySelector('input[type="radio"][name*="-swatch"]:checked');
      var mediaId = input && input.getAttribute('data-option-media-id');
      if (mediaId) info.variantImage = showSlide(node, mediaId);
      if (!info.variantImage) warn('variante ' + req.variant + ' sem foto própria no card — ficou a foto padrão');
    }
    var img = node.querySelector('slideshow-slide:not([hidden]) img') || node.querySelector('.card-gallery img') || node.querySelector('img');
    if (img) { img.setAttribute('loading', 'eager'); img.setAttribute('fetchpriority', 'high'); }
    return info;
  }

  // Mesma troca que o tema faz ao clicar numa bolinha (#updateVariantImages),
  // mas no card ainda fora da página: o slide da cor vira o 1º visível.
  function showSlide(node, mediaId) {
    var slides = node.querySelectorAll('slideshow-slide[variant-image]');
    var target = null;
    for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('slide-id') === mediaId) target = slides[i];
    if (!target) return false;
    for (var j = 0; j < slides.length; j++) {
      if (slides[j] === target) slides[j].removeAttribute('hidden');
      else slides[j].setAttribute('hidden', '');
    }
    var parent = target.parentElement;
    if (parent && parent.firstElementChild !== target) parent.insertBefore(target, parent.firstElementChild);
    return true;
  }

  function fillSlot(li, built) {
    while (li.firstChild) li.removeChild(li.firstChild);
    li.appendChild(built.frag);
    li.classList.remove('ee-pin-slot');
    li.classList.remove('ee-pin-loading');
    if (built.productId) li.setAttribute('data-product-id', built.productId);
    li.classList.add('ee-pin-pinned');
  }

  function fetchCard(req) {
    var early = E.cardPromise && E.cardKey === cardUrl(req) ? E.cardPromise : null;
    var primary = (early || getText(cardUrl(req))).then(function (t) {
      var b = buildCard(t, req);
      if (!b) throw new Error('modelo ee-pin-card sem o card de ' + req.handle);
      return b;
    });
    return primary.catch(function (err) {
      warn(err.message + ' — tentando o card do BMP');
      return getText(bmpCardUrl(req)).then(function (t) {
        var b = buildCard(t, req);
        if (!b) throw new Error('produto ' + req.handle + ' não encontrado');
        return b;
      });
    });
  }

  /* ---------- coleção "source" ---------- */

  function applySource(grid, htmlText, req) {
    var doc = new DOMParser().parseFromString(htmlText, 'text/html');
    var srcGrid = doc.querySelector('[ref="grid"]') || doc.querySelector('.product-grid');
    if (!srcGrid) throw new Error('coleção ' + req.source + ' sem grade');
    var srcCards = getCards(srcGrid);
    if (!srcCards.length) throw new Error('coleção ' + req.source + ' vazia');
    var old = getCards(grid);
    var anchor = old.length ? old[0] : null;
    for (var i = 0; i < srcCards.length; i++) grid.insertBefore(document.importNode(srcCards[i], true), anchor);
    for (var k = 0; k < old.length; k++) old[k].parentNode.removeChild(old[k]);
    // paginação: passa a ser a da coleção source (sem section_id)
    var list = grid.closest('results-list') || document;
    var pag = list.querySelector('nav.pagination');
    var srcPag = doc.querySelector('nav.pagination');
    if (pag && srcPag) {
      var fresh = document.importNode(srcPag, true);
      var as = fresh.querySelectorAll('a[href]');
      for (var a = 0; a < as.length; a++) {
        try {
          var u = new URL(as[a].getAttribute('href'), location.origin);
          var p = u.searchParams.get('page');
          var nu = root() + 'collections/' + encodeURIComponent(req.source) + (p ? '?page=' + p : '');
          if (req.sortBy) nu += (p ? '&' : '?') + 'sort_by=' + encodeURIComponent(req.sortBy);
          as[a].setAttribute('href', nu);
          as[a].removeAttribute('on:click');
        } catch (e) { /* mantém */ }
      }
      pag.parentNode.replaceChild(fresh, pag);
    } else if (pag) {
      pag.style.display = 'none';
    }
  }

  /* ---------- limit ---------- */

  function applyLimit(grid, req) {
    if (!req.limit) return;
    var cards = getCards(grid);
    for (var i = req.limit; i < cards.length; i++) cards[i].parentNode.removeChild(cards[i]);
    var list = grid.closest('results-list') || document;
    var pag = list.querySelector('nav.pagination');
    if (pag) pag.style.display = 'none';
  }

  /* ---------- fluxo principal ---------- */

  function pin(grid, req) {
    var existing = findCard(grid, req.handle);
    var needFetch = !existing || !!req.variant;
    var slot;

    if (existing) {
      moveToFront(grid, existing);
      slot = existing;
      if (req.variant) slot.classList.add('ee-pin-loading');
      else slot.classList.add('ee-pin-pinned');
    } else {
      slot = makePlaceholder(grid);
      var first = getCards(grid)[0];
      grid.insertBefore(slot, first || null);
    }
    applyLimit(grid, req);
    reveal();

    if (!needFetch) return;
    withDeadline(fetchCard(req), CARD_TIMEOUT).then(function (built) {
      if (!slot.isConnected) return;
      // não duplicar: se o produto apareceu na grade por outro caminho, fica o da grade
      var dup = findCard(grid, req.handle);
      if (dup && dup !== slot) { finishFailed(slot, existing); return; }
      fillSlot(slot, built);
    }).catch(function (err) {
      warn('card não fixado: ' + err.message);
      finishFailed(slot, existing);
    });
  }

  function finishFailed(slot, existing) {
    if (existing) {
      existing.classList.remove('ee-pin-loading');
      existing.classList.add('ee-pin-pinned');
    } else if (slot.parentNode) {
      slot.parentNode.removeChild(slot);
    }
  }

  function run() {
    try {
      var req = E.req || parseRequest(location.search);
      if (!req) { reveal(); return; }
      E.req = req;
      // O failsafe do boot já mostrou a grade: mexer agora seria um salto visível.
      if (E.revealed) { warn('script chegou depois do failsafe; coleção fica como veio'); return; }

      if (document.querySelector('script[data-bmp-curated-first]')) {
        warn('"BMP Curated First" está ligado nas configurações do tema; o da EE fica desligado.');
        reveal();
        return;
      }

      var grid = getGrid();
      if (!grid || !getCards(grid).length) { reveal(); return; }

      // Página 2 em diante: o produto já apareceu na 1ª — não repetir.
      if (req.page > 1) {
        var again = findCard(grid, req.handle);
        if (again) again.parentNode.removeChild(again);
        reveal();
        return;
      }

      var list = grid.closest('results-list');
      var mainId = (list && list.getAttribute('section-id')) || E.main;
      if (req.source && req.source !== (E.coll || '') && mainId) {
        var sp = E.sourcePromise && E.sourceKey === sourceUrl(req, mainId) ? E.sourcePromise : getText(sourceUrl(req, mainId));
        withDeadline(sp, SOURCE_TIMEOUT).then(function (t) {
          if (E.revealed) throw new Error('prazo do failsafe');
          applySource(grid, t, req);
        }).catch(function (err) {
          warn('source "' + req.source + '" não aplicado: ' + err.message);
        }).then(function () {
          html.classList.remove('ee-pin-src');
          if (E.revealed) { reveal(); return; }
          pin(grid, req);
        });
        return;
      }

      pin(grid, req);
    } catch (err) {
      warn(err && err.message);
      reveal();
    }
  }

  // exposto para teste/diagnóstico
  E.parse = parseRequest;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
